<template>
  <div>
    <img v-if="!color" src="../assets/icons/spinner.svg" class="ico-17 fa-spin" />
    <img v-else-if="color === 'pink'" src="../assets/icons/spinner_pink.svg" class="ico-17 fa-spin" />
  </div>
</template>
<script>
export default {
  name: "spinner",
  props: {
    color: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>